import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SalesInvoiceImport = _resolveComponent("SalesInvoiceImport")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!

  return (_openBlock(), _createBlock(_component_oss_dialog, {
    modelValue: _ctx.dialog,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialog) = $event)),
    key: _ctx.reload,
    title: "Factures de vente CSV et EXCEL",
    "valid-title": "Importer",
    actions: _ctx.importActions,
    validLoading: _ctx.loadingValidate
  }, {
    default: _withCtx(() => [
      _createVNode(_component_SalesInvoiceImport, {
        ref: "importComponent",
        actions: _ctx.importActions,
        documentType: 'SALES_INVOICE',
        selectedCompanyId: _ctx.companyId,
        onDocumentImported: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onDocumentImported()))
      }, null, 8, ["actions", "selectedCompanyId"])
    ]),
    _: 1
  }, 8, ["modelValue", "actions", "validLoading"]))
}